import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import PageTitle from '../../Layout/Components/PageTitle';

import Strings from '../../translations/Translations';
import AnalyzeModule from '../../modules/campaign/analyze/AnalyzeModule';

export default function Analyze() {
  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={Strings('analyze')}
          subheading=""
          icon="pe-7s-graph1"
        />

        <Row>
          <Col>
            <AnalyzeModule />
          </Col>
        </Row>
      </PageAnimation>
    </Fragment>
  );
}
